import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import TimeReport from "../../model2/time-report/time-report"
import TasksResourcesCollection from "./tasks"
import MeetingsResourcesCollection from "./meetings"

export default class TimeReportsResourcesCollection extends ResourcesCollectionProto {

    constructor(resources:Resources, data: any[] = [], options:any = {}) {
        super(resources, data, TimeReport, options)
    }

    removeByTaskId(taskID:ID) {
        _.map(this.models, (timeReport:TimeReport)=>{
            if (timeReport.taskId === taskID) {
                this.remove(timeReport.id)
            }
        })
    }

    linkTasks(tasksCollection: TasksResourcesCollection | null) {

        if (!tasksCollection) return

        _.map(this.models, (timeReport)=>{
            // a meeting report has no task - don't overwrite its entity with undefined
            if (timeReport.meetingId) return

            timeReport.task = tasksCollection.get(timeReport.taskId)
        })
    }

    // aggregate endpoints send only meetingId, daily sends a compact meeting inline on every report.
    // either way a report must point at the resources' Meeting instance - session deltas are applied
    // there, and a per-report copy (built by the TimeReport constructor) would keep the old name.
    // a report whose meeting is not in the collection keeps its own copy
    linkMeetings(meetingsCollection: MeetingsResourcesCollection | null) {

        if (!meetingsCollection) {
            return
        }

        _.map(this.models, (timeReport: TimeReport)=>{
            if (!timeReport.meetingId) {
                return
            }

            timeReport.meeting = meetingsCollection.get(timeReport.meetingId) ?? timeReport.meeting
        })
    }
}
